export const STRIPE_PLANS = {
  inicial: {
    productId: "prod_Tua1xnDLxpejB4",
    productIdYearly: "prod_TvWx2Z51k9Jcyo", // Produto anual parcelado (cobrança mensal)
    name: "Essencial",
    monthly: {
      priceId: "price_1SxXDxPyoEfa2XRBqi1MkvjA",
      price: 384.99,
    },
    yearly: {
      priceId: "price_1SxftVPyoEfa2XRB5xrEHww2", // Preço ativo: R$349,99/mês
      pricePerMonth: 349.99,
      totalPrice: 4199.88,
      commitmentMonths: 12,
    },
  },
  intermediario: {
    productId: "prod_Tua1UBhbDv9Eua",
    productIdYearly: "prod_TvWyT61EVRUGS0", // Produto anual parcelado (cobrança mensal)
    name: "Plus",
    monthly: {
      priceId: "price_1SwkrbPyoEfa2XRBz4po3XQA",
      price: 659.99,
    },
    yearly: {
      priceId: "price_1SxfuXPyoEfa2XRBCBt1Jem0", // Preço ativo: R$599,99/mês
      pricePerMonth: 599.99,
      totalPrice: 7199.88,
      commitmentMonths: 12,
    },
  },
  pro: {
    productId: "prod_Tua26xiREYeLeu",
    productIdYearly: "prod_TvWyGbnvNR4Rua", // Produto anual parcelado (cobrança mensal)
    name: "PRO",
    monthly: {
      priceId: "price_1SwkrxPyoEfa2XRBdUBtqXpf",
      price: 1649.99,
    },
    yearly: {
      priceId: "price_1SxfuhPyoEfa2XRBxBgcKTLB", // Preço ativo: R$1.499,99/mês
      pricePerMonth: 1499.99,
      totalPrice: 17999.88,
      commitmentMonths: 12,
    },
  },
} as const;

export type PlanType = keyof typeof STRIPE_PLANS;
export type WorkspacePlanKey = PlanType | "enterprise";
export type BillingPeriod = "monthly" | "yearly";

export function normalizeWorkspacePlanKey(plan: string | null | undefined): WorkspacePlanKey {
  if (plan === "intermediario" || plan === "pro" || plan === "enterprise") return plan;
  return "inicial";
}

export function getWorkspacePlanDisplayName(plan: string | null | undefined): string {
  const key = normalizeWorkspacePlanKey(plan);
  if (key === "enterprise") return "Enterprise";
  return STRIPE_PLANS[key].name;
}

/** Valor mensal de referência (tabela mensal Stripe) em BRL. Enterprise retorna null. */
export function getWorkspacePlanMonthlyPriceBrl(plan: string | null | undefined): number | null {
  const key = normalizeWorkspacePlanKey(plan);
  if (key === "enterprise") return null;
  return STRIPE_PLANS[key].monthly.price;
}

// Produtos anuais parcelados (cobrança mensal com compromisso de 12 meses)
export const ANNUAL_INSTALLMENT_PRODUCTS = [
  "prod_TvWx2Z51k9Jcyo", // Essencial Anual Parcelado
  "prod_TvWyT61EVRUGS0", // Plus Anual Parcelado
  "prod_TvWyGbnvNR4Rua", // PRO Anual Parcelado
] as const;

// Mapeamento de todos os product_ids para planos
// Inclui produtos mensais, anuais parcelados e legados sandbox para compatibilidade
export const PRODUCT_ID_TO_PLAN: Record<string, PlanType> = {
  // Produtos mensais - ATIVOS
  "prod_Tua1xnDLxpejB4": "inicial",
  "prod_Tua1UBhbDv9Eua": "intermediario",
  "prod_Tua26xiREYeLeu": "pro",
  // Produtos anuais parcelados - ATIVOS (cobrança mensal com compromisso 12 meses)
  "prod_TvWx2Z51k9Jcyo": "inicial",
  "prod_TvWyT61EVRUGS0": "intermediario",
  "prod_TvWyGbnvNR4Rua": "pro",
  // Produtos anuais antigos (cobrança única anual) - manter para assinaturas existentes
  "prod_TvO3dyIV6OgX3g": "inicial",
  "prod_TvO3a3nyFWrO9Q": "intermediario",
  "prod_TvO4yQWZDEdXLB": "pro",
  // Sandbox legados (manter para assinaturas existentes)
  "prod_TjgkZ0AMDIm4Ma": "inicial",
  "prod_TRozwHE7HSzuv3": "inicial",
  "prod_TRp1ijIhwHkpVH": "intermediario",
  "prod_TRp1EjvLD8Ll72": "pro",
};

export const getPlanByProductId = (productId: string): PlanType | null => {
  return PRODUCT_ID_TO_PLAN[productId] || null;
};

// Helper para obter o priceId baseado no período
export const getPriceId = (planKey: PlanType, period: BillingPeriod): string => {
  const plan = STRIPE_PLANS[planKey];
  return period === "monthly" ? plan.monthly.priceId : plan.yearly.priceId;
};

// Helper para obter o productId baseado no período
export const getProductId = (planKey: PlanType, period: BillingPeriod): string => {
  const plan = STRIPE_PLANS[planKey];
  return period === "monthly" ? plan.productId : plan.productIdYearly;
};

// Helper para verificar se um produto é anual parcelado (com compromisso)
export const isAnnualInstallmentProduct = (productId: string): boolean => {
  return ANNUAL_INSTALLMENT_PRODUCTS.includes(productId as any);
};
